<template>
    <div :class="panelClass" :style="panelStyle">
        <!-- [COLLAPSE] Items -->
        <div :class="collapseLabelClass" @click="toggleSide">
            <ur-icon>slide_left</ur-icon>
        </div>
        <div :class="collapseLabelHideClass">{{title}}</div>
        <div :class="panelContentClass">
            <slot/>
        </div>
    </div>
</template>

<script>
    // ur-panel은 화면의 숨겨진 영역에서 Panel을 꺼낼 때  사용하는 컴포넌트입니다.
    // 설정값에 따라 화면의 사이드 영역에서 나오게 됩니다.
    // #ur-panel is a component that sliding move to side on browser.
    export default {
        name:'ur-panel',
        props: {
            // $ver: v0.2.0
            // Panel의 위치를 결정합니다.
            // #Define for location
            // $default: 'right'
            location: {
                type: String,
                default: 'right'
            },
            // $ver: v0.2.0
            // Panel을 우측에 위치시킵니다.
            // #Define for location position right
            // $default: false
            right: { type: Boolean, default: false},
            // $ver: v0.2.0
            // Panel을 좌측에 위치시킵니다.
            // #Define for location position left
            // $default: false
            left: { type: Boolean, default: false},
            // $ver: v0.2.0
            // Panel을 우측에 위치시킵니다.
            // #Define for location position top
            // $default: false
            top: { type: Boolean, default: false},
            // $ver: v0.2.0
            // Panel을 아래쪽에 위치시킵니다.
            // #Define for location position bottom
            // $default: false
            bottom: { type: Boolean, default: false},
            // $ver: v0.2.0
            // Panel의 기본 시작점을 잡는다.
            // #Define for default location panel
            // $default: 0
            pivot: { type: [String, Number], default: 0},
            // $ver: v0.2.0
            // Panel의 기본 타이틀을 정한다.
            // #Define for default panel title
            // $default: 'Panel'
            title: { type: [String], default: 'Panel'}
        },
        data() {
            return {
                toggleSideClose: true,
            }
        },
        computed: {
            rocation(){
                let location = this.location;
                if(this.right){location = 'right'}
                if(this.left){location = 'left'}
                if(this.top){location = 'top'}
                if(this.bottom){location = 'bottom'}
                return location;
            },
            panelClass(){
                let clazz = [];
                clazz.push('ur-panel-'+this.rocation);
                if(this.toggleSideClose){
                    clazz.push('ur-panel-'+this.rocation+'__collapse');
                }
                return clazz;
            },
            panelStyle(){
                let style = {};
                if(this.right && this.pivot) {style['right'] = this.getNumber(this.pivot) + 'px';}
                if(this.left && this.pivot) {style['left'] = this.getNumber(this.pivot) + 'px';}
                if(this.top && this.pivot) {style['top'] = this.getNumber(this.pivot) + 'px';}
                if(this.bottom && this.pivot) {style['bottom'] = this.getNumber(this.pivot) + 'px';}
                return style;
            },
            collapseLabelClass(){
                return 'ur-panel-'+this.rocation+'__collapse-label'
            },
            collapseLabelHideClass(){
                return 'ur-panel-'+this.rocation+'__collapse-hide';
            },
            panelContentClass(){
                return 'ur-panel-'+this.rocation+'__content-wrapper';
            }
        },
        methods:{
            toggleSide(){
                this.toggleSideClose = !this.toggleSideClose;
            },
            getNumber(str) {
                let v = str;
                if(isNaN(v)) {
                    v = v.replace(/[^0-9]/g,"");
                }
                return parseInt(v);
            }
        }
    }
</script>
